import { render } from "./listCategorieProduit.vue?vue&type=template&id=60edf539&scoped=true"
import script from "./listCategorieProduit.vue?vue&type=script&lang=js"
export * from "./listCategorieProduit.vue?vue&type=script&lang=js"

import "./listCategorieProduit.vue?vue&type=style&index=0&id=60edf539&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Latitude E5570\\Desktop\\MES DOSSIERS\\REAL_ESTATE_DEXTER\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60edf539"]])

export default __exports__